import { BeatLoader } from "react-spinners";

export const ChatLoader = ({ color }) => {
  return (
    <div>
      <BeatLoader
        color={color ? color : "black"}
        cssOverride={{}}
        loading
        size={8}
        speedMultiplier={1}
      />
    </div>
  );
};
